import { getWindowConfig, } from '~/utils/env';
import { MeterRead, } from './meter-read';

MeterRead('#app', (s) => getWindowConfig(s));
